import Icon from 'snippets/icon/icon'

export function FieldBanner({ icon, content, className }) {
  return (
    <div className={`w-full rounded-md ${className ?? ''}`}>
      <div className={'flex flex-row items-center gap-2 p-2'}>
        <Icon id={icon} className="min-w-4" />
        <div>
          <p className={'paragraph-xs leading-4 text-primary-black'}>{content}</p>
        </div>
      </div>
    </div>
  )
}
